import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { MatBadgeModule } from '@angular/material/badge';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppTranslateModule } from '@core/app-translate.module';
import { DialogModule } from '@shared/dialog/dialog.module';
import { WaiFormControlsModule } from '@feature/forms/form-controls/form-controls.module';

import { SubscriptionTierBadgeComponent } from './subscription-tier-badge/subscription-tier-badge.component';
import { SubscriptionUpgradeDialogComponent } from './subscription-upgrade-dialog/subscription-upgrade-dialog.component';
import { TrialCountdownBannerComponent } from './trial-countdown-banner/trial-countdown-banner.component';
import { GpAddonSelectorComponent } from './gp-addon-selector/gp-addon-selector.component';
import { TierLimitsIndicatorComponent } from './tier-limits-indicator/tier-limits-indicator.component';
import { SepaPaymentSetupComponent } from './sepa-payment-setup/sepa-payment-setup.component';
import { SubscriptionContractSigningComponent } from './subscription-contract-signing/subscription-contract-signing.component';
import { PaymentStatusBannerComponent } from './payment-status-banner/payment-status-banner.component';
import { UpdatePaymentMethodDialogComponent } from './update-payment-method-dialog/update-payment-method-dialog.component';
import { BillingHubSummaryComponent } from './billing-hub-summary/billing-hub-summary.component';

export const imports: NgModule['imports'] = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  FlexLayoutModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatTooltipModule,
  MatRadioModule,
  MatListModule,
  MatBadgeModule,
  TranslateModule,
  AppTranslateModule,
  WaiFormControlsModule,
];

@NgModule({
  declarations: [
    SubscriptionTierBadgeComponent,
    SubscriptionUpgradeDialogComponent,
    TrialCountdownBannerComponent,
    GpAddonSelectorComponent,
    TierLimitsIndicatorComponent,
    SepaPaymentSetupComponent,
    SubscriptionContractSigningComponent,
    PaymentStatusBannerComponent,
    UpdatePaymentMethodDialogComponent,
    BillingHubSummaryComponent,
  ],
  imports: [...imports, DialogModule],
  exports: [
    SubscriptionTierBadgeComponent,
    SubscriptionUpgradeDialogComponent,
    TrialCountdownBannerComponent,
    GpAddonSelectorComponent,
    TierLimitsIndicatorComponent,
    SepaPaymentSetupComponent,
    PaymentStatusBannerComponent,
    BillingHubSummaryComponent,
  ],
})
export class SubscriptionModule {}
